import { render, staticRenderFns } from "./Jornalzinho.vue?vue&type=template&id=5f819046&scoped=true&"
import script from "./Jornalzinho.vue?vue&type=script&lang=js&"
export * from "./Jornalzinho.vue?vue&type=script&lang=js&"
import style0 from "./jornalzinho.scss?vue&type=style&index=0&id=5f819046&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f819046",
  null
  
)

export default component.exports